/**
 * ResultSummary - Exibe resumo final da exportação
 */

import { CheckCircleIcon as CheckCircle, AlertCircleIcon as AlertCircle } from '../../icons';
import { MODAL_STYLES } from '../constants';
import type { ExportResult } from '../types';
import { Button } from '../../ui';

interface ResultSummaryProps {
  result: ExportResult;
  onClose: () => void;
}

export function ResultSummary({ result, onClose }: ResultSummaryProps) {
  const { summary, files, outputDir, format } = result;
  const hasErrors = summary.failed > 0;
  const wasCancelled = summary.cancelled;
  
  return (
    <div className="space-y-3">
      {/* Status icon */}
      <div className="flex items-center justify-center">
        {hasErrors || wasCancelled ? (
          <div className="w-12 h-12 rounded-full bg-yellow-900/30 flex items-center justify-center">
            <AlertCircle className="w-6 h-6 text-yellow-500" />
          </div>
        ) : (
          <div className="w-12 h-12 rounded-full bg-green-900/30 flex items-center justify-center">
            <CheckCircle className="w-6 h-6 text-green-500" />
          </div>
        )}
      </div>
      
      {/* Título */}
      <div className="text-center">
        <h3 className="text-lg font-semibold text-white mb-1">
          {wasCancelled 
            ? 'Exportação Cancelada'
            : hasErrors
            ? 'Exportação Concluída com Erros'
            : 'Exportação Concluída'}
        </h3>
        <p className="text-sm text-gray-400">
          {wasCancelled
            ? 'Alguns arquivos podem ter sido exportados'
            : hasErrors
            ? 'Alguns arquivos não foram exportados'
            : 'Todos os arquivos foram exportados com sucesso'}
        </p>
      </div>
      
      {/* Estatísticas */}
      <div className="bg-navy-700/30 rounded-lg p-3 space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Total de objetos:</span>
          <span className="text-white font-medium">{summary.total}</span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Exportados:</span>
          <span className="text-green-400 font-medium">{summary.success}</span>
        </div>
        
        {summary.failed > 0 && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-gray-400">Falharam:</span>
            <span className="text-red-400 font-medium">{summary.failed}</span>
          </div>
        )}
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Tempo:</span>
          <span className="text-white font-medium">
            {(summary.duration_ms / 1000).toFixed(1)}s
          </span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Formato:</span>
          <span className="text-white font-medium uppercase">{format}</span>
        </div>
      </div>
      
      {/* Diretório */}
      <div className="bg-navy-700/30 rounded-lg p-3">
        <div className="text-xs text-gray-400 mb-1">Diretório de saída:</div>
        <div className="text-xs text-gray-200 font-mono break-all">{outputDir}</div>
      </div>
      
      {/* Botão fechar */}
      <Button
        variant="primary"
        onClick={onClose}
        aria-label="Fechar modal"
        className="w-full"
      >
        Fechar
      </Button>
    </div>
  );
}

